import { createAction } from '@reduxjs/toolkit'
import { CreateEmployeeTransitPassPayload } from './transitPassTypes'

const createTransitPassProgramSuccess = createAction(
  'transitPass/createTransitPassProgramSuccess'
)

const updateTransitPassProgramSuccess = createAction(
  'transitPass/updateTransitPassProgramSuccess'
)

const cancelTransitPassProgramSuccess = createAction(
  'transitPass/cancelTransitPassProgramSuccess'
)

const getEmployeeTransitPasses = createAction(
  'transitPass/getEmployeeTransitPasses'
)

const createEmployeeTransitPass = createAction<CreateEmployeeTransitPassPayload>(
  'transitPass/createEmployeeTransitPass'
)

export const transitPassActions = {
  createTransitPassProgramSuccess,
  updateTransitPassProgramSuccess,
  cancelTransitPassProgramSuccess,
  getEmployeeTransitPasses,
  createEmployeeTransitPass,
}
